<section class="eligibility-delay-section">
    <div class="eligibility-delay-icon-wrapper">
        <i class="icon icon-edponline-Bra-107 eligibility-delay-icon"></i>
    </div>
    <div class="eligibility-delay-title-wrapper">
        <p class="eligibility-delay-title">{{ "pt.edp.edponline.eligibility.delay.page.title" | translate }}</p>
    </div>
    <div class="eligibility-delay-description-wrapper">
        <p
            class="eligibility-delay-description"
            [innerHTML]="'pt.edp.edponline.eligibility.delay.page.description' | translate: { EMAIL: email }"
        ></p>
    </div>

    <div *ngIf="!isPage" class="eligibility-delay-custom-button-wrapper">
        <button class="eligibility-delay-custom-button" (click)="close()">
            {{ "pt.edp.edponline.eligibility.delay.button.label" | translate }}
        </button>
    </div>
</section>
